export const bseStatesList  = [
  {
    "code": "AN",
    "name": "Andaman & Nicobar"
  },
  {
    "code": "AR",
    "name": "Arunachal Pradesh"
  },
  {
    "code": "AP",
    "name": "Andhra Pradesh"
  },
  {
    "code": "AS",
    "name": "Assam"
  },
  {
    "code": "BH",
    "name": "Bihar"
  },
  {
    "code": "CH",
    "name": "Chandigarh"
  },
  {
    "code": "CG",
    "name": "Chhattisgarh"
  },
  {
    "code": "GO",
    "name": "GOA"
  },
  {
    "code": "GU",
    "name": "Gujarat"
  },
  {
    "code": "HA",
    "name": "Haryana"
  },
  {
    "code": "HP",
    "name": "Himachal Pradesh"
  },
  {
    "code": "JM",
    "name": "Jammu & Kashmir"
  },
  {
    "code": "JK",
    "name": "Jharkhand"
  },
  {
    "code": "KA",
    "name": "Karnataka"
  },
  {
    "code": "KE",
    "name": "Kerala"
  },
  {
    "code": "MP",
    "name": "Madhya Pradesh"
  },
  {
    "code": "MA",
    "name": "Maharashtra"
  },
  {
    "code": "MN",
    "name": "Manipur"
  },
  {
    "code": "ME",
    "name": "Meghalaya"
  },
  {
    "code": "MI",
    "name": "Mizoram"
  },
  {
    "code": "NA",
    "name": "Nagaland"
  },
  {
    "code": "ND",
    "name": "New Delhi"
  },
  {
    "code": "OR",
    "name": "Orissa"
  },
  {
    "code": "PO",
    "name": "Pondicherry"
  },
  {
    "code": "PU",
    "name": "Punjab"
  },
  {
    "code": "RA",
    "name": "Rajasthan"
  },
  {
    "code": "SI",
    "name": "Sikkim"
  },
  {
    "code": "TG",
    "name": "Telengana"
  },
  {
    "code": "TN",
    "name": "Tamil Nadu"
  },
  {
    "code": "TR",
    "name": "Tripura"
  },
  {
    "code": "UP",
    "name": "Uttar Pradesh"
  },
  {
    "code": "UC",
    "name": "Uttaranchal"
  },
  {
    "code": "WB",
    "name": "West Bengal"
  },
  {
    "code": "DN",
    "name": "Dadra and Nagar Haveli"
  },
  {
    "code": "DD",
    "name": "Daman and Diu"
  },
  {
    "code": "LD",
    "name": "Lakshadweep"
  },
  {
    "code": "OH",
    "name": "Others"
  }
]
